const state = {
  items: [],
}

const getters = {
  quantidade() {
    return state.items.length
  },
  mensagem() {
    return state.items.length>1 ? (state.items.length+" itens no carrinho") : (state.items.length==1 ? "1 item no carrinho" : "Nenhum item no carrinho")
  }
}

export default {
  state,
  getters
}
